import { DialogSize } from '@thyme/nashville/src/types/dialogs'
import { computed, ref, SetupContext } from 'vue'
import { KnowledgeBaseLlmResponse } from '@/libs/features/llm/types'
import { AskSopInputForm } from './AskSOPModalInputs/types'
import { getKnowledgeBaseResponse } from './queries'
import { useKnowledgeBaseLlmApi } from './store'

/**
 *
 * @param props
 * @param context
 */
export default function (props: any, context: SetupContext) {
  const llmApi = useKnowledgeBaseLlmApi()
  const inputs = ref<AskSopInputForm | undefined>(undefined)
  const response = ref<KnowledgeBaseLlmResponse | undefined>(undefined)
  const loading = computed(() => llmApi.isLoading)
  const error = ref<Error | undefined>(undefined)

  const close = () => {
    context.emit('close')
  }

  /**
   *
   */
  function reset() {
    response.value = undefined
    error.value = undefined
    inputs.value = undefined
  }

  /**
   *
   * @param data
   */
  async function submitQuery(data: AskSopInputForm) {
    try {
      response.value = await getKnowledgeBaseResponse(data, props.showDevTools)
      inputs.value = data
    } catch (err) {
      error.value = err as Error
    }
  }

  return {
    response,
    loading,
    error,
    inputs,
    submitQuery,
    close,
    reset,
    DialogSize,
  }
}
